import { useQuery } from '@tanstack/react-query';
import { brandingApi } from '@/lib/api';

export interface Branding {
  hospital_address:          string;
  hospital_phone:            string;
  hospital_email:            string;
  branding_logo:             string;
  branding_tagline:          string;
  branding_license_no:       string;
  branding_rx_footer:        string;
  branding_invoice_footer:   string;
  branding_lab_footer:       string;
  branding_radiology_footer: string;
  // Full-width document header images (base64 data URL; empty = use text fallback)
  print_header_prescription: string;
  print_header_invoice:      string;
  print_header_lab:          string;
  print_header_radiology:    string;
  // true  → doctor credentials are on pre-printed letterhead; skip the standalone block on Rx
  // false → system renders doctor name, qualifications, and Reg No below the header
  doctor_details_in_header:  boolean;
  // Rich-text HTML injected into print layouts (stored as sanitized HTML strings)
  prescription_custom_header_html: string;
  prescription_footer_html:        string;
  receipt_custom_header_html:      string;
  receipt_footer_html:             string;
}

export type PrintHeaderType = 'prescription' | 'invoice' | 'lab' | 'radiology';

export function useBranding() {
  return useQuery<Branding>({
    queryKey: ['branding'],
    queryFn:  () => brandingApi.get().then(r => {
      const raw = r.data as Record<string, string>;
      return {
        ...raw,
        doctor_details_in_header: raw.doctor_details_in_header === '1',
      } as Branding;
    }),
    staleTime: 5 * 60_000,
  });
}
